// import NewTicketContainer from "../containers/NewTicketContainer"
// import MyTicketsContainer from "../containers/MyTicketsContainer"
import * as supportRoutes from './supportRoutes';
import SupportContainer from '../containers/SupportContainer';
import TicketContainer from '../containers/TicketContainer';

export const SupportRoutes = [
  // {
  //     key: "new-ticket",
  //     exact: true,
  //     path: supportRoutes.NEW_TICKET,
  //     component: NewTicketContainer,
  // },
  // {
  //     key: "my-tickets",
  //     exact: true,
  //     path: supportRoutes.MY_TICKETS,
  //     component: MyTicketsContainer,
  // },
  {
    key: 'ticket',
    exact: true,
    path: supportRoutes.TICKET,
    component: TicketContainer
  },
  {
    key: 'support',
    exact: true,
    path: supportRoutes.SUPPORT,
    component: SupportContainer
  }
];
